import Banner from "./components/Banner";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ListeMurs from "./features/murs/ListeMurs";
import MurDeBrique from "./features/murs/MurDeBrique";
import CreerMur from "./features/murs/creerMur";
import ModifierMur from "./features/murs/ModifierMur";
import JouerNiveau from './features/murs/JouerNiveau';
import Accueil from "./features/murs/Accueil";
import Connexion from "./components/Auth/Connexion";
import Inscription from "./components/Auth/Inscription";
import { AuthProvider } from "./components/context/AuthContext";
import DemandeReset from "./components/Auth/DemandeReset.tsx";
import ListeUtilisateurs from "./components/Auth/ListeUtilisateurs.tsx";
import NouveauxMurs from "./components/NouveauxMurs.js"


import './styles/global.css';

function App() {
    return (
        <AuthProvider>
            <Router>
                <div>
                    <Banner />
                    <Routes>
                        <Route path="/" element={<Accueil />} />
                        <Route path="/connexion" element={<Connexion />} />
                        <Route path="/inscription" element={<Inscription />} />
                        <Route path="/murs" element={<ListeMurs />} />
                        <Route path="/MurDeBrique/:murId" element={<MurDeBrique />} />
                        <Route path="/creer-mur" element={<CreerMur />} />
                        <Route path="/modifier-mur/:murId" element={<ModifierMur />} />
                        <Route path="/jouer/:murId" element={<JouerNiveau />} />
                        <Route path="/mot-de-passe-oublie" element={<DemandeReset />} />
                        <Route path="/admin/utilisateurs" element={<ListeUtilisateurs />} />
                        <Route path="/nouveaux-murs" element={<NouveauxMurs />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;